import { useAtomValue } from 'jotai';
import { Box } from '@mui/material';
import {
  CuboidTransformButtonGroup,
  VerticalDivider,
} from '@/modules/cuboids/components/CuboidToolbar';
import { useCuboidState } from '../hooks/useCuboidState';
import { CuboidDoneButtonGroup } from './CuboidDoneButtonGroup';
import { CuboidPointVisibilityControls } from '@/modules/cuboids/components/CuboidToolbar/CuboidPointVisibilityControls';

export const CuboidToolbar = () => {
  const cuboidState = useCuboidState();
  const currentCuboid = useAtomValue(cuboidState.currentCuboid);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', mr: 5 }}>
      {/* <AddCuboidButton cuboidState={cuboidState} /> */}

      {currentCuboid && (
        <>
          {/* <HidePointsOutsideCuboidControl cuboidState={cuboidState} /> */}

          <CuboidPointVisibilityControls cuboidState={cuboidState} />

          <VerticalDivider />

          <CuboidTransformButtonGroup cuboidState={cuboidState} />

          <VerticalDivider />

          <CuboidDoneButtonGroup />
        </>
      )}
    </Box>
  );
};
